import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Format } from 'services/Dates'
import BaseModalActions from 'components/Modals/BaseModalActions'
import useUpdateSettings from '../../UI/Filter/hooks/useUpdateSettings'
import useDateFilterOptions from '../../UI/Filter/hooks/useDateFilterOptions'
import { DateTimePicker } from '../../UI'
import { Button as MerinioButton, List } from 'ui'
import { MFilters } from 'types/filterTypes'

import { t } from 'translations'

type DropDownDateFilterButtonModalProps = {
  contentName: MFilters.ContentTypes
  withTime?: boolean
}

const DropDownDateFilterButtonModal: FC<DropDownDateFilterButtonModalProps> = ({ contentName, withTime }) => {
  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const settings = useSelector((state: MStore.RootState) => state.settings)
  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])
  const { getDateRange, dateOption, datesOptions } = useDateFilterOptions(contentName, withTime)
  const rangeStart = 'rangeStart' in savedOptions ? savedOptions.rangeStart : ''
  const rangeEnd = 'rangeEnd' in savedOptions ? savedOptions.rangeEnd : ''

  const { saveOptions } = useUpdateSettings(contentName)

  const onDateFilterChange = (dates: string[]) => {
    if (dates.length === 2) {
      saveOptions(
        {
          ...savedOptions,
          rangeStart: Format(dates[0], { outFormat: withTime ? 'server' : 'date' }),
          rangeEnd: Format(dates[1], { outFormat: withTime ? 'server' : 'date' })
        },
        {}
      )
    }
  }

  const datePickerOptions = {
    inline: true,
    mode: 'range',
    dateFormat: withTime ? 'Y-m-dTH:i' : 'Y-m-d',
    enableTime: withTime
  }

  return (
    <BaseModalActions>
      <List className="pb-2">
        <List.Item className="px-0">
          {datesOptions.map((option, index) => (
            <MerinioButton
              key={index}
              className={`dropdown-item d-flex justify-content-between ${dateOption === option ? 'active' : ''}`}
              onClick={() => saveOptions({ ...savedOptions, ...getDateRange(option) })}
            >
              {t(`searchBar.${option}`)}
            </MerinioButton>
          ))}
          <div>
            <hr></hr>
          </div>
          <div className="d-flex justify-content-center">
            <DateTimePicker
              onChange={(values: string[]) => {
                if (values?.length === 2) {
                  onDateFilterChange(values)
                }
              }}
              options={datePickerOptions}
              value={rangeStart && rangeEnd ? [rangeStart, rangeEnd] : null}
            />
          </div>
        </List.Item>
      </List>
    </BaseModalActions>
  )
}

export default DropDownDateFilterButtonModal
